import { renderComponent } from './utils/utils';
import { initTranslations } from './services/i18n/i18n';
import { initStore } from './services/configuration/configuration-store';
import { SettingsComponent } from './components/settings/settings.component';
import { logger } from './services/bi-logger/bi-logger-service';
function getStaticsUrl() {
  const _window = window;
  const staticsRoot = 'https://static.parastorage.com/services/cookie-consent-banner-for-uou/';
  let staticsUrl = '';
  if (_window.staticsBaseUrl) {
    staticsUrl = _window.staticsBaseUrl;
  }
  if (_window.wixTagManager && typeof _window.wixTagManager.getConfig === 'function') {
    var _window$wixTagManager;
    staticsUrl = (_window$wixTagManager = _window.wixTagManager.getConfig()) == null ? void 0 : _window$wixTagManager.wixBannerStatics;
  }
  if (!staticsUrl) {
    const scripts = document.getElementsByTagName('script');
    Array.prototype.forEach.call(scripts, script => {
      if (!staticsUrl && script.src.indexOf(staticsRoot) > -1) {
        const version = script.src.split(staticsRoot)[1].split('/').shift();
        staticsUrl = "" + staticsRoot + version + "/";
      }
    });
  }
  return staticsUrl;
}
export async function openSettingModal() {
  var _window$wixEmbedsAPI;
  await initStore();
  logger.openedPanel('component');
  const locale = ((_window$wixEmbedsAPI = window.wixEmbedsAPI) == null ? void 0 : _window$wixEmbedsAPI.getLanguage()) || 'en';
  const staticUrl = getStaticsUrl();
  await initTranslations(staticUrl, locale, () => {
    void renderComponent(new SettingsComponent(), document.body);
  });
}
//# sourceMappingURL=client.js.map